import {useQuery} from "@apollo/client";
import {useEffect, useState} from "react";

import {
    DeliveryTaskReviewWithCountType,
    DeliveryTaskReviewWithCountTypeResponse,
    GET_DELIVERY_TASK_REVIEWS_WITH_COUNT
} from "../graphql/queries/getDeliveryTaskReviewsWithCount";
import {ReviewFilterType} from "../graphql/types/ReviewFilterType";
import {formatTaskDateRangeToISO} from "../../../../utils/dateTimeUtils";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";

export interface WmsReviewQueryResult {
    reviewData: DeliveryTaskReviewWithCountType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    buildQueryVariables: () => any;
}

export const useWmsParcelQuery = (
    filters: ReviewFilterType,
    warehouseId?: number
): WmsReviewQueryResult => {
    const [reviewData, setReviewData] = useState<DeliveryTaskReviewWithCountType[]>([]);
    const [loading, setLoading] = useState(true);

    const buildQueryVariables = () => {
        return {
            filter: {
                taskDateRange: filters.taskDate ? formatTaskDateRangeToISO(filters.taskDate) : null,
                dspId: filters.dspId ? parseInt(filters.dspId) : null,
                accountId: filters.driverAccountId ? parseInt(filters.driverAccountId) : null,
                warehouseId: Number(warehouseId)
            }
        };
    };

    const {data, loading: queryLoading, refetch} = useQuery<DeliveryTaskReviewWithCountTypeResponse>(
        GET_DELIVERY_TASK_REVIEWS_WITH_COUNT,
        {
            variables: buildQueryVariables(),
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'no-cache'
        }
    );

    useEffect(() => {
        const responseData = data?.getDeliveryTaskReviewsWithCount || [];
        if (responseData) {
            setReviewData(responseData);
        }
        setLoading(false);
    }, [data]);

    // 监听warehouseId变化，重新获取数据
    useEffect(() => {
        if (warehouseId) {
            setReviewData([]);
            setLoading(true);
            // 重新获取列表数据（会触发 fetchDeliverCount）
            refetch(buildQueryVariables());
        }
    }, [warehouseId]);

    return {
        reviewData,
        loading: loading || queryLoading,
        refetch,
        buildQueryVariables
    };
}; 